<form [formGroup]="folderForm" class="drop-padding createFolderForm" (ngSubmit)="save()">
  <mat-form-field appearance="outline">
    <mat-label>Наименование</mat-label>
    <input matInput type="text" formControlName="description" />
  </mat-form-field>
  <button mat-flat-button color="primary" [disabled]="loading">
    {{ loading ? 'Загрузка' : 'Сохранить' }}
  </button>
</form>
